import wrapperFactory from "../util/wrapper-factory.js";

export default async function signupForm() {
  const exported = await wrapperFactory({ name: "guest-signup-form-v1" });
  return exported.default;
}
